export const FCM = {
    REGISTER_DEVICE_TOKEN: 'fcm/REGISTER_DEVICE_TOKEN', 
    REMOVE_DEVICE_TOKEN: 'fcm/REMOVE_DEVICE_TOKEN'
};